// src/utils/perfMonitor.js
// Performance réelle perçue par les élèves (Web Vitals) : un seul événement par chargement de page,
// envoyé 15 s après le load pour laisser LCP/CLS se stabiliser — `web_vitals` (info) ou
// `web_vitals_poor` (warning) si au moins une métrique est dans la zone « mauvaise ».
// Seuils : ceux publiés par Google (web.dev/vitals). web-vitals 2.x ne fournit pas de « rating ».
import MonitoringService from '../services/MonitoringService';
import { auth } from '../firebaseConfig';
import { deviceInfo } from './staveRenderMonitor';

const FLUSH_DELAY_MS = 15000;
const THRESHOLDS = { lcp: [2500, 4000], fcp: [1800, 3000], fid: [100, 300], cls: [0.1, 0.25], ttfb: [800, 1800] };

export function rate(name, value) {
  const [good, poor] = THRESHOLDS[name];
  return value <= good ? 'good' : (value <= poor ? 'needs-improvement' : 'poor');
}

export function initPerfMonitor() {
  try {
    const values = {};
    const landingPage = window.location.pathname;
    const record = (name) => (m) => { values[name] = name === 'cls' ? Math.round(m.value * 1000) / 1000 : Math.round(m.value); };

    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(record('cls'), true);
      getFID(record('fid'));
      getFCP(record('fcp'));
      getLCP(record('lcp'), true);
      getTTFB(record('ttfb'));
    }).catch(() => {});

    const flush = () => {
      try {
        if (Object.keys(values).length === 0) return;
        const ratings = {};
        Object.entries(values).forEach(([k, v]) => { ratings[k] = rate(k, v); });
        const poor = Object.keys(ratings).filter(k => ratings[k] === 'poor');
        const conn = navigator.connection || {};
        const params = {
          exerciseId: landingPage,
          landingPage,
          ...values,
          poor: poor.join(',') || null,
          connection: conn.effectiveType || null,
          saveData: !!conn.saveData,
          memoryGb: navigator.deviceMemory || null,
          cores: navigator.hardwareConcurrency || null,
          ...deviceInfo(),
        };
        const uid = auth.currentUser?.uid || null;
        if (poor.length) MonitoringService.warning('web_vitals_poor', params, uid);
        else MonitoringService.info('web_vitals', params, uid);
      } catch { /* silencieux */ }
    };

    const start = () => setTimeout(flush, FLUSH_DELAY_MS);
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  } catch { /* silencieux */ }
}
